import { useState } from 'react';
import { Box, Center, Heading, RadioGroup, Stack, Text } from '@chakra-ui/react';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/800.css';
import * as yup from 'yup';
import { FormStep } from '../MultiStepForm';
import RadioField from '../RadioField';

export default function Pronouns(props: { onSubmit: any, validationSchema: any }) {
    const { onSubmit, validationSchema } = props;

    return (
        <FormStep
            stepName="pronouns"
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            <Center>
                <Box w="350px">
                    <Stack align="center">
                        <Heading
                            lineHeight="36px"
                            fontSize="32px"
                            letterSpacing="-0.02em"
                            fontWeight="800"
                            width="530px"
                            textAlign="center"
                        >
                            Tell us more about you
                        </Heading>
                        <Text fontWeight={400} lineHeight="20px" fontSize="16px" align="center">
                            What are your preferred pronouns?
                        </Text>
                        <Box alignItems="center" alignSelf="center" w="350px">
                            <RadioGroup id="pronounGroup">
                                <RadioField
                                    name="pronouns"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="She/Her"
                                    text="She/Her"
                                    topMargin="8px"
                                />
                                <RadioField
                                    name="pronouns"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="He/Him"
                                    text="He/Him"
                                    topMargin="8px"
                                />
                                <RadioField
                                    name="pronouns"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="They/Them"
                                    text="They/Them"
                                    topMargin="8px"
                                />
                                <RadioField
                                    name="pronouns"
                                    align="center"
                                    width="100px"
                                    type="radiobutton"
                                    value="Other"
                                    text="Other"
                                    topMargin="8px"
                                />
                            </RadioGroup>
                        </Box>
                    </Stack>
                </Box>
            </Center>
        </FormStep>
    );
}
